export default {
  pager: (state) => state.pager,
  nutrition: (state) => state.nutrition,
  mealplans: (state) => state.mealplans,
  habit: (state) => state.habit,
  habits: (state) => state.habits,
  habitIcons: (state) => state.habitIcons,
}
